import moment from "moment";
import classes from "./FreeSlots.module.scss";

const FreeSlots = (props) => {
  const dataToShow = props.freeSlots.filter(
    (elem) => elem.date === moment(props.selectedDay).format("YYYY-MM-DD")
  );
  const renderFreeSlot = (time, index) => {
    const isSelected =
      time && props.selectedTime
        ? time.slotts === props.selectedTime.slotts
        : false;

    return (
      <button
        key={index}
        className={
          classes[isSelected ? "free-slot-time-selected" : "free-slot-time"]
        }
        onClick={() => props.onTimeSelected(time)}
      >
        {time.time}
      </button>
    );
  };

  return (
    <div className={classes["free-slots-container"]}>
      {dataToShow.length > 0 ? (
        dataToShow[0].slots.map((freeSlot) => {
          if (freeSlot.times.length > 0) {
            return (
              <div className={classes["free-slot-container"]}>
                <span className={classes["free-slot-name"]}>
                  {freeSlot.name}
                </span>
                <div className={classes["free-slot-times-container"]}>
                  {freeSlot.times.map(renderFreeSlot)}
                </div>
              </div>
            );
          }
        })
      ) : (
        <div>
          <h1>Nessun orario disponibile</h1>
        </div>
      )}
      {dataToShow[0]?.slots[0]?.times?.length === 0 &&
        dataToShow[0]?.slots[1]?.times?.length === 0 && (
          <div>
            <h1>Nessun orario disponibile</h1>
          </div>
        )}
    </div>
  );
};

export default FreeSlots;
